// extracted by mini-css-extract-plugin
export var carrierIcon = "_wb-0";
export var carrierLogo = "_wb-1";
export var detailsSection = "_wb-2";